export const InvoiceTypeEnum = [
    { title: 'Standard Invoice', value: 0 }, //Full Payment
    { title: 'Payment Plan', value: 1 },
    { title: 'Scheduled One Time', value: 2 },
    { title: 'Subscription', value: 3 },
    { title: 'Split Payment', value: 4 },
    { title: 'Prepaid Balance', value: 5 },
]